import React, { Component } from 'react';
import { ContentCard } from '../Cards';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {FaAngleDoubleLeft, FaDownload, FaEye } from 'react-icons/fa';
import { fetchPackageFinish } from '../../actions/EnrollmentActions';
import { fetchGetDocumentBlobForEmployee, fetchGetDocumentBlobForEmployeeAsBlob } from '../../actions/DocumentActions';
import DocumentViewer from '../DocumentViewer/DocumentViewer';
import { PackageType } from '../../types/enums/PackageType';


class Finish extends Component {
    state = {
        loadingDocument: false,
        showPDFModal: false,
        currentDocumentName: "",
        currentDocumentBlob: "",
        arePlanDocumentsLoading: false
    };

    _mounted = false;
    
    componentDidMount() {
        if (this.props.packageId) {
            this.props.fetchPackageFinish(this.props.packageId);
            this._mounted = true;
        }
    }

    componentWillUnmount(){
        this._mounted = false;
    }

    onBack = () => {
        if (this.props.activePackage) {
            this.props.history.push(`/packages/${this.props.activePackage.enrollmentPackageId}/summary`);
        }
    };

    getDocumentBlob = (packageId, document) => {
        if(this._mounted){
            this.setState({loadingDocument: true}, () => {
                this.props.fetchEmployeeDocument(packageId, document.documentId)
                    .then((results) => {
                        if(this._mounted){
                            this.setState({
                                currentDocumentName: document.fileName,
                                currentDocumentBlob: results,
                                showPDFModal: true,
                                loadingDocument: false
                            });
                        }
                    });
            });
        }
    };

    togglePDFModal = () => {
        const { showPDFModal } = this.state;
        if(this._mounted){
            this.setState({
                showPDFModal: !showPDFModal
            });
        }
    };

    renderPackageDocuments = packageDocuments => {
        return packageDocuments.map((document, index) => {
            return (
                <tr key={`pd-${index}`}>
                    <td>
                        {document.fileName}
                    </td>
                    <td>
                        <div className="btn-group" role="group">
                            <button type="button" className="btn btn-sm btn-outline-success" onClick={() => this.getDocumentBlob(this.props.packageId, document)}><FaEye /></button>
                            <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.props.downloadEmployeeDocument(this.props.packageId, document.documentId)}><FaDownload /></button>
                        </div>
                    </td>
                </tr>
            );
        });
    };

    render() {
        const { showPDFModal, currentDocumentBlob, currentDocumentName } = this.state;
        const { data, error, loading } = this.props.finishPage;

        const packageDocuments = data ? data.packageDocuments : null;

        // Hacky way to fix this for GTFF for now
        const shouldShowEnrollmentCompletedHeader = this.props.activePackage?.packageTypeId !== PackageType.PublicEnrollment;

        return (
            <React.Fragment>
                <DocumentViewer toggleModal={this.togglePDFModal} showModal={showPDFModal} fileName={currentDocumentName} blob={currentDocumentBlob} />
                <ContentCard loading={loading} error={error}>
                    { shouldShowEnrollmentCompletedHeader && <h2>Enrollment Completed</h2> }
                    {data && <div dangerouslySetInnerHTML={{ __html: data.content }} />}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-between">
                                <button disabled={!this.props.activePackage} type="button" className="btn btn-default mr-2" onClick={e => this.onBack(e)}><FaAngleDoubleLeft /> Back</button>
                            </div>
                        </div>
                    </div>
                    <div className="table-wrapper mt-4">
                        <table className="table table-hover mb-4">
                            <thead>
                                <tr>
                                    <th>Enrollment Documents</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {data && !data.loading && packageDocuments && this.renderPackageDocuments(packageDocuments)}
                            </tbody>
                        </table>
                    </div>
                </ContentCard>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activePackage: state.packages.activePackage.data,
        finishPage: state.enrollment.finishPage,
        packageDocuments: state.enrollment.packageDocuments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPackageFinish: (packageId) => {
            dispatch(fetchPackageFinish(packageId));
        },
        downloadEmployeeDocument: (packageId, documentId) =>{
            return dispatch(fetchGetDocumentBlobForEmployee(packageId, documentId));
        },
        fetchEmployeeDocument: (packageId, documentId) => {
            return dispatch(fetchGetDocumentBlobForEmployeeAsBlob(packageId, documentId));
        },
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Finish));